// extracted by mini-css-extract-plugin
export var button = "_lc-0";
export var donut = "_lc-1";
export var donutFill = "_lc-3";
export var donutTrack = "_lc-2";